import { AuthenticatedTemplate } from "@azure/msal-react";
import { Outlet } from "react-router";
import useGetAuthToken from "./useGetAuthToken";
import AzureAuthProvider from "../providers/AzureAuthProvider";

export const AuthenticatedLayout = () => {
  const getAuthToken = useGetAuthToken();

  const authComplete = getAuthToken !== undefined;

  return (
    <AuthenticatedTemplate>
      {authComplete && (
        <AzureAuthProvider.Provider value={getAuthToken}>
          <Outlet />
        </AzureAuthProvider.Provider>
      )}
    </AuthenticatedTemplate>
  );
};
